import Api from "../apiService";

class vehiclesApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/vehicles`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, vehicleId) {
    return Api.getRequest(
      `companies/${companyId}/vehicles/${vehicleId}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, vehicleData) {
    return Api.postRequest(
      `companies/${companyId}/vehicles`,
      vehicleData,
      Api.authHeaders()
    );
  }

  update(companyId, vehicleId, vehicleData) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${vehicleId}`,
      vehicleData,
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }

  export(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/vehicles/export`,
      params,
      Api.authHeaders(),
      { responseType: "blob" } // важно для получения файла
    );
  }
}

export default new vehiclesApi();
